import { RulerIcon } from 'lucide-react'
import type { MeasurementSystem } from '@/shared/domain'
import { useToast, useUnits } from '@/shared/ui/providers'
import { ToggleGroup, ToggleGroupItem } from '@/shared/ui/primitives'

export function UnitsToggle() {
  const { system, setSystem } = useUnits()
  const toast = useToast()

  function handleChange(next: string) {
    if (next !== 'imperial' && next !== 'metric') return
    setSystem(next as MeasurementSystem).catch(() => {
      toast.error('Could not save units preference', 'Please try again.')
    })
  }

  return (
    <div className="flex items-center gap-2 px-2 py-1.5">
      <RulerIcon aria-hidden="true" className="size-4 shrink-0 text-muted-foreground" />
      <ToggleGroup
        type="single"
        value={system}
        onValueChange={handleChange}
        aria-label="Measurement units"
        className="flex-1"
      >
        <ToggleGroupItem value="imperial" aria-label="Imperial units" className="h-7 flex-1 text-xs">
          Imperial
        </ToggleGroupItem>
        <ToggleGroupItem value="metric" aria-label="Metric units" className="h-7 flex-1 text-xs">
          Metric
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  )
}
